<!--  世界杯  金币版 --->
<template>
<div class="world-cup">
    <TopBanner class="top-banner" :banner="banner" />
    <div class="container">
      
       
        <div class="media-show">
            <div class="right-banner"><img src="https://media3.imgyb.xyz/media/v1/image/21e6051ebe909db03640b4f3b91c19fb.jpeg" alt=""></div>
            <ForecastGold />
        </div>
        <div class="cont-row g-grid">
            <div class="flex-cont ovhd">
                <GuessingGold />
                
                
            </div>
            <div class="rank-list">
                
                <div class="right-banner"><img src="https://media3.imgyb.xyz/media/v1/image/21e6051ebe909db03640b4f3b91c19fb.jpeg" alt=""></div>
                <ForecastGold />
                
                <GamblersGold />
                <OftenWinGold />
            </div>
        </div>
    </div>
    <CssFooter></CssFooter> 
</div>
</template>
<script>
import TopBanner from '@/components/widgets/top-banner.vue'
import MyMoneyInfo from './components/my-money-info.vue'
import sponser from './components/sponser.vue'
import JoinTrends from './components/join-trends.vue'
import ForecastGold from './components/forecast-gold.vue'
import GamblersGold from './components/gamblers-gold.vue'
import OftenWinGold from './components/often-win-gold.vue'
import GuessingGold from './components/guessing-gold.vue'

import YorkbbsInfoflowItem from '@/components/item-infoflow.vue'
import ItemSubject from './components/item-subject.vue'
import CssFooter from '@/components/css-footer.vue'
export default {
    name:'WorldCupGold2022',
    components:{TopBanner,MyMoneyInfo,sponser,JoinTrends,ForecastGold,GamblersGold,OftenWinGold,GuessingGold,YorkbbsInfoflowItem,ItemSubject,CssFooter},
    data(){
        return {
            banner:{
                pcBanner:'https://media5.imgyb.xyz/media/v1/image/d0e0535d58ee0c8d8979818c63dab918.png',
                pcBannerBg:'https://media7.imgyb.xyz/media/v1/image/bbd0fbee3c3032fd045960724cb60f05.png',
                mBanner:'https://media2.imgyb.xyz/media/v1/image/fd4b21302417fd8c84fa88b2d7a919f2.png',
            },
           
        }
    },
    
    


}
</script>
<style lang="less" scoped>
.world-cup{background: #f8f8f8;}
.container{width:1170px; margin:0 auto;}
.rank-list{width:340px; margin-left: 30px;}
.g-grid{align-items: flex-start;}
.full-show{display: block;}
.media-show{display: none;}
.right-banner{
    img{display: block; width: 100%;}
}
.top-banner{margin-bottom: 30px;}
@media screen and (min-width:768px){
    .world-cup{min-width: 1170px;}
}
@media screen and (max-width:768px){
    .world-cup{background: #fff;}
    .container{
        width:100%; padding: 0 10px; box-sizing: border-box;
    }
    .g-grid{
        flex-direction: column;
        .rank-list{
            width:100%; margin-left: 0;
        }
    }
    .top-banner{margin-bottom: 10px;}
}
</style>